export enum EOperationalHelpSurface {
  StoreOwner = 0,
  Reseller = 1,
  Courier = 2,
}
